// /home/clement/compta-app/client/src/components/Stocks/Produits/ListeProduitsServices.js

import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Alert,
} from "@mui/material";

const ListeProduitsServices = () => {
  const [produitsServices, setProduitsServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduitsServices = async () => {
      try {
        const response = await axios.get("/api/produits-services");
        setProduitsServices(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProduitsServices();
  }, []);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <Alert severity="error" style={{ marginTop: "20px" }}>
        Erreur lors de la récupération des produits/services : {error}
      </Alert>
    );
  }

  return (
    <div className="liste-produits-services">
      <h2>Liste des Produits/Services</h2>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nom</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Prix</TableCell>
              <TableCell>Type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {produitsServices.map((produitService) => (
              <TableRow key={produitService.id}>
                <TableCell>{produitService.id}</TableCell>
                <TableCell>{produitService.nom}</TableCell>
                <TableCell>{produitService.description}</TableCell>
                <TableCell>{produitService.prix} €</TableCell>
                <TableCell>{produitService.type}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ListeProduitsServices;
